<div class="container-fluid margin0 p-0 bg-primary flex-center-content full-screen">
  <div class="text-center">
    <img class="loading-logo" [src]="imgUrl" />
    <br />
    <i class="fa fa-spin fa-circle-notch fa-2x color-spin"></i>
  </div>
</div>
<script src="https://js.stripe.com/v3/"></script>
